import React from 'react';
import bgImage from './../../scripts/bg-image';
import { colors, fonts } from './../../styles/theme.json';

const ItunesButton = (props) => (
    <div className={'itunes-button'}>
      <a className={'itunes-link'} href={props.ItunesLink} target={'_blank'}>
        <span className={'apple-icon'} style={bgImage('/static/icons/apple.png')}/>
        <span className={'itunes-text'}>{'View in iTunes'}</span>
      </a>
      <style jsx>{`
        .itunes-button {
          //margin-top: 3rem;
          margin-bottom: 5rem;
        }
        .itunes-link {
          padding: 1.15rem 2.518rem;
          font-size: ${fonts.small};
          color: ${colors.black};
          border: 1px solid ${colors.black};
          font-weight: 700;
          display: inline-flex;
          flex-direction: row;
          align-items: center;
        }
        .itunes-text {
          padding-top: .2rem;
        }
        .apple-icon {
          width: 1.2rem;
          height: 1.4rem;
          background-size: contain;
          display: block;
          position: relative;
          margin-right: .4rem;
        }
        @media (max-width: 640px) {
          .itunes-button, .itunes-link {
            //width: 100%;
          }
        }
        @media (min-width: 640px) {
          .itunes-button {
            margin-bottom: 0;
          }
        }
      `}</style>
    </div>
  );

export default ItunesButton;



// WEBPACK FOOTER //
// ./src/components/photo-film-project/ItunesButton.js